import { QueryEntity } from '@datorama/akita';
import { getPropertyDeviceStore, PropertyDeviceState } from './property-device.store';
import { switchMap } from 'rxjs/operators';

export class PropertyDeviceQuery extends QueryEntity<PropertyDeviceState> {
  devices = this.select(({ ui }) => ui).pipe(
    switchMap(ui =>
      this.selectAll({
        filterBy: [
          x =>
            !ui.thingIdentifier ||
            !x.thingIdentifier ||
            x.thingIdentifier?.toLowerCase().startsWith(ui.thingIdentifier?.toLowerCase()),
          x => !ui.thingType || x.thingType === ui.thingType,
          x => !ui.thingLocationType || x.thingLocationType === ui.thingLocationType,
          x => !ui.thingStatus || x.powerStatus === ui.thingStatus,
        ],
      })
    )
  );

  pagination = this.select(({ pagination }) => pagination);

  isLoading = this.selectLoading();
}

// REPLACE with a lazy getter function:
let _query: PropertyDeviceQuery | undefined;
export function getPropertyDeviceQuery(): PropertyDeviceQuery {
  if (!_query) {
    _query = new PropertyDeviceQuery(getPropertyDeviceStore());
  }
  return _query;
}
